import { render, staticRenderFns } from "./BecomeInstructorForm.vue?vue&type=template&id=d44e0142"
import script from "./BecomeInstructorForm.vue?vue&type=script&lang=js"
export * from "./BecomeInstructorForm.vue?vue&type=script&lang=js"
import style0 from "./BecomeInstructorForm.vue?vue&type=style&index=0&id=d44e0142&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports